export const apiUrls = {
  productReferenceUrl: '/homeservices/productreference.model.json',
};
